import { FC } from 'react';

// ========================= 组件 =========================

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================
import classname from 'classnames';

// ========================= 样式 =========================
import styles from './DetailTitle.module.css';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface DetailTitleProps {
    /**
     * @description: 文本内容
     * @return {*}
     */
    title: string;
    /**
     * @description: 标题容器 默认H2
     * @return {*}
     */
    HtmlContainer?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
    /**
     * @description: 上边距
     * @return {*}
     */
    paddingTop?: number | string;
    paddingBottom?: number | string;
    className?: string;
}

const DetailTitle: FC<DetailTitleProps> = ({ title, HtmlContainer = 'h2', className }) => {
    return (
        <div
            className={
                classname(styles.DetailTitle, className)
            }
        >
            <HtmlContainer className={styles['TitleText']}>{title}</HtmlContainer>
        </div>
    );
}
export default DetailTitle;